import { render, staticRenderFns } from "./TpFooter.vue?vue&type=template&id=93df1ffc&scoped=true&"
var script = {}
import style0 from "./TpFooter.vue?vue&type=style&index=0&id=93df1ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93df1ffc",
  null
  
)

export default component.exports